import { useQuery } from '@base-app/web2'
import { COLLABORATOR_FUNCTIONS_QUERY } from '../graphql/collaboratorFunctions/queries'
import type { CollaboratorFunction } from '../graphql/collaboratorFunctions/types'

// An application has at most 50 functions and the API pages at most 100, so one page holds the whole
// list. The collaborators page and form share these exact variables, so they read the same cache
// entry instead of asking twice.
const FUNCTIONS_LIMIT = 100

// One stable reference while there is no data, so memos that depend on the list don't re-run
const NO_FUNCTIONS: CollaboratorFunction[] = []

// Every function of an application (value = key, label = name) for checkboxes and name lookups
export function useCollaboratorFunctionList(clientId: string, appId: string) {
  const { data, loading, error, refetch } = useQuery(COLLABORATOR_FUNCTIONS_QUERY, {
    variables: { clientId, applicationId: appId, limit: FUNCTIONS_LIMIT },
    // Functions change on their own page and by other admins: show the cached list, then refresh it
    fetchPolicy: 'cache-and-network',
  })
  return {
    functions: data?.collaboratorFunctions ?? NO_FUNCTIONS,
    loading: loading && !data,
    // The list is what the API answered just now, not a cached copy still being refreshed
    settled: !loading && !error,
    error,
    refetch,
  }
}
